import { Paper } from '@trackman/web-shared-components';
import { DragIndicator } from 'pages/SetLineup/components/TeamSetup/TeamLineup/TeamLineupStyles';
import { Name, TaggingLineupPlayerWrapper } from 'pages/Tagging/components/Lineup/TaggingLineupPlayerStyles';
import React from 'react';
import styled from 'styled-components';
import { black } from 'styles/Colors';
import { ReactComponent as EditIcon } from 'components/icons/edit.svg';

export const Batters = styled.div`
  height: calc(100% - 68px);
  overflow: auto;
  display: block;
  ${TaggingLineupPlayerWrapper} {
    &.disabled {
      cursor: default !important;
    }
    ${Name} {
      flex: 4;
    }
    .jersey-number {
      position: static;
    }
  }
  @media screen and (-webkit-min-device-pixel-ratio: 0) {
    overflow: hidden;
    &:hover {
      overflow-y: auto;
    }
    &::-webkit-scrollbar {
      width: 2px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 3.5px;
    }
    &::-webkit-scrollbar-thumb {
      background-image: linear-gradient(179deg, $darkgrey, rgba(65, 65, 65, 0.82));
      border-radius: 3.5px;
    }
  }
`;

export const TaggingColumn = styled((props) => <Paper {...props} />)`
  padding: 6px 5px !important;
  overflow-y: auto;
  height: 100%;
`;

export const StyledEditLineupIcon = styled((props) => <EditIcon {...props} />)`
  position: absolute;
  top: -2px;
  right: 10px;
  cursor: pointer;
`;

export const BpLineupListWrapper = styled.div`
  ${DragIndicator} {
    position: absolute;
    width: 100%;
    height: 6px;
    top: calc(50% - 3px);
    background-color: ${black};
  }
`;
